import { virtualLinkClick } from "../utilities/links";
// polyfill fetch
import 'react-app-polyfill/ie11';
import 'url-search-params-polyfill';
import { errorModal } from "../utilities/modal-popup";
import { getElementDataset } from "../utilities/dataRetrieval";
import { setupAnalytics } from './analytics/default';
import { researchReportView } from './analytics/events/researchReport';

const urlSearchParams = new URLSearchParams(window.location.search);

// prevent tracking mobile web views within apps
if (urlSearchParams.has('bodyOnly') === false) {
    const analytics = setupAnalytics();
    const eventData = getElementDataset({ selector: '[data-research-report]' }) || {};
    analytics.trackEvent(researchReportView(eventData));
}

export default (function () {
    (function($) {

        const researchDownload = $('#researchPdfDownload');

        // research download is the id tag on research tool published reports download button.
        // If the button does not exist the report will not contain the RT download button and and does not contain idToken
        // nor will it contain research related reports so this file can perform an early exit.
        if (researchDownload.length === 0) {
            return;
        }

        const researchId = researchDownload.data('researchid');
        const idToken = atob(researchDownload.data('idtoken'));
        const accessToken = atob(researchDownload.data('accesstoken'));
        const isImpersonated = researchDownload.data('isimpersonated') === true;

        const urlParams = new URLSearchParams(window.location.search);
        const bodyOnlyParam = 'bodyOnly';
        const isBodyOnly = urlParams.get(bodyOnlyParam) === 'true';

        jQuery(function() {
            if (isBodyOnly) {
                // remove all link from body as it cannot be clickable on mobile. Only allow the following links to be present:
                // - related research links
                // - nav scroll targets
                const links = $('.research-integration__content a').not('.related-research-link').not('.research-integration__nav-target');

                links.replaceWith(function () {
                    return $(this).text();
                });
            }

            const relatedArticles = $('.related-research-link');

            if (relatedArticles.length === 0) {
                return;
            }

            relatedArticles.each(function () {
                let url =  $(this).attr('href') + '?accessToken=' + accessToken;
                // bodyOnly is not passed so we can open the related report in a new tab
                if (isBodyOnly) {
                    url += '&' + bodyOnlyParam + '=true';
                    $(this).removeAttr('target', '_blank')
                } else {
                    $(this).attr('target', '_blank')
                }

                $(this).attr('href', url);
            })
        });

        researchDownload.on('click touch', function (e) {
            // allow mobile apps to handle mobile specific links
            if (isBodyOnly || isImpersonated) {
                return;
            }

            e.preventDefault();

            fetch(
                `${process.env.API_BASE_URL}/research/${researchId}/pdf`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `${idToken}`,
                        'User-Agent': navigator.userAgent,
                        'x-api-key': process.env.API_AUTHORISED_KEY,
                        origin: window.location.origin,
                    },
                },
            )
                .then((response) => {
                    if (response.ok === false) {
                        throw new Error;
                    }

                    return response;
                })
                .then((response) => response.json())
                .then(({code, payload }) => {
                    if (code > 299) {
                        throw new Error;
                    }

                    const { data: { url } } = payload;
                    virtualLinkClick(url);
                })
                .catch(() => {
                    const articleNameElement = $('.web-header__title--main');
                    const articleName = articleNameElement.length > 0 ? articleNameElement.text() + ' ' : '';
                    const errorMessage = `${articleName}PDF is not available at this time.`;

                    errorModal.setup({
                        errorMessage,
                    });
                    errorModal.open();
                });
        });
    })(jQuery);
})();
